<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-diagnosed" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Wann wurde bei Ihnen Diabetes festgestellt?</span>
            <p class="new-text-lg text-centered">Bitte geben Sie das Jahr an, in dem bei Ihnen erstmals Typ-2-Diabetes diagnostiziert wurde.</p>
        </header>

        <div class="form-input-wrapper">
            <span class="form-input-title new-text-xl text-bold">Wählen Sie das Jahr</span>

            <div class="input-wrapper form-input-date-wrapper">
                <form-input-type-select
                    name="diagnosed_year"
                    :options="getYears"
                    :value="diagnoseYear"
                    :errors="errors.diagnose_year"
                    full-border
                    label="Jahr"
                    required
                />
            </div>

            <v-button
                label="Weiter"
                size="lg"
                type="submit"
                @onClick="onClickButton()"
                full-width
            ></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                errors: {
                    date: null
                },
                isDisabled: true,
                diagnoseYear: this.data && this.data.diagnose_year,
            }
        },

        mounted() {
            const that = this

            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50);
        },

        computed: {
            getYears() {
                var years = []

                for (let index = moment().year(); index > 1960; index--) {
                    years.push({label: index.toString(),})
                }

                return years
            }
        },

        methods: {
            onClickButton() {
                this.validate()

                if(!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                }
            },
            validate() {
                if($("#diagnosed_year").val() == "") {
                    this.errors.diagnose_year = ["Das Jahr muss angegeben werden"]
                    this.isDisabled = true
                    this.$forceUpdate();
                } else {
                    this.diagnoseYear = $("#diagnosed_year").val()
                    this.isDisabled = false
                    this.$forceUpdate();
                }
            },
            submit() {
                var data = {
                    uuid: this.uuid,
                    answers: {
                        question_1: {
                            key: 'diagnose_year',
                            value: this.diagnoseYear
                        },
                        last_tab: {
                            key: 'last_tab',
                            value: '3'
                        }
                    }
                }

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
            saveData() {
                var data = {
                    answers: {
                        question_1: {
                            key: 'diagnose_year',
                            value: this.diagnoseYear
                        }
                    }
                }

                this.$emit('clicked', data.answers, false)
            }
        }
    }
</script>
